import { EditorCard } from "@/shared/components/editor/editor-card";
import { useState } from "react";
import {
  useVbsTreatmentShowQuery,
  useVbsTreatmentUpdateRemarkMutation,
} from "@/services/backend/vbs/treatments/api/treatment-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import t from "@/lang/lang";

export function TreatmentRemark({
  treatmentId,
  disabled = false,
}: {
  treatmentId: string;
  disabled?: boolean;
}) {
  const { data: treatment } = useVbsTreatmentShowQuery({ id: treatmentId });

  const [request, setRequest] = useState({
    id: treatmentId,
    remark: treatment?.remark ?? "",
  });

  const mutation = useVbsTreatmentUpdateRemarkMutation();

  useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: treatmentId,
      remark: treatment?.remark ?? "",
    },
    { delay: 1000 },
  );

  if (!treatment) return null;

  return (
    <EditorCard
      title={t("Kundenspezifische Bemerkung")}
      description={t(
        "Diese Bemerkung wird auf dem Leistungsverzeichnis gedruckt.",
      )}
      initialHtml={treatment.remark}
      onHtmlChange={(html) => setRequest({ ...request, remark: html })}
      disabled={disabled}
    />
  );
}
